import { Component , OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ConnectionService } from './../services/connection.service';
import { CborDataDecorator } from './../core/app.core.cbor';

@Component({
  selector: 'connection',
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.scss'],
  providers: [ CborDataDecorator ]  ,
  standalone: !true
})
export class ConnectionComponent implements OnInit {
	connection$: Observable<string>;
	
	  ngOnInit(): void {
		    this.connection$ =  this.сonnectionComponent.getConnectionStatus();
		  }
	  
		constructor(private сonnectionComponent: ConnectionService) {
			
			 this.connection$ = сonnectionComponent.getConnectionStatus();
		}
		 
	  // Метод для обработки события
	  onChangeString(): void {
	    this.сonnectionComponent.updateConnectionStatus('');
	  }	  
}